import React, { useState, useEffect, useContext } from 'react';
import {Select} from '@thinkwell/react.polaris'
import { SectionsContext } from './contexts/yolk/Sections'

export default function SectionsSelect(props) {
  const [sections, fetchSections, fetchSectionsState] = useContext(SectionsContext)

  const idFormat = props.idFormat || ((item) => item.id || item.section_id)

  const formName = props.name || 'section_id'

  const options = sections.map((item) => {
    return {
      value: idFormat(item),
      label: `${(item.organization_name || item.organization || item.school)} - ${(item.course_name || item.course)} - ${(item.name || item.section)}`
    }
  })

  return (
    <Select
      required={props.required}
      label={{singular: 'section', plural: 'sections'}}
      name={formName}
      options={options}
      fetchState={fetchSectionsState}
      onChange={props.onChange}
      notFoundMessage={props.notFoundMessage}
    />
  );
}
